import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import { Button, IconButton, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import _ from "lodash";
import React, { useCallback, useState } from "react";
import { useSelector } from "react-redux";

import { LoadingButton } from "@mui/lab";
import { Fileuploadrequestcall } from "../../../../request/Fileuploadrequest";
import { Postrequestcall } from "../../../../request/Postrequest";
import { imageCompress } from "../../../../assets/helpers";
import {
  SAVE_CLIENT_TIMESHEET_JOB_IMAGES,
  SAVE_CLIENT_TIMESHEETS,
  SAVE_CLIENT_TIMESHEETS_NEW
} from "../../../../constant/Apipath";
import TodayDatePicker from "../../../component/TodayDatePicker";
import ConfirmModal from "../../promptModal/ConfirmModal";
import DeletConfirmModal from "../../promptModal/DeletConfirmModal";
import { fetchCrewTimesheet } from "../../ViewTimesheet/ClientTimesheetViewIndividual";
import { JobsListingManual } from "./JobsListingManual";
import SelectJobsManual from "./SelectJobsManual";
import { ClientEnglishFallback } from "../../../constant/ClientEnglishFallback";

export const VIEW = {
  LISTING: "LISTING",
  SELECT_JOBS: "SELECT_JOBS"
};

export default function ClientTimesheetManualComponent({
  FOR,
  view,
  modelState,
  reloadData,
  handleClose,
  setModelState,
  setView
}) {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const CLIENT_COLOR = selectedClientData?.AccentColor;
  const EMPid = selectedClientData?.ClientEmployeeId;
  const userId = loginData?.userInformation?.UserId;

  const [jobs, setJobs] = useState([]);
  const [date, setDate] = useState(dayjs());
  const [loading, setLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteJobIndex, setDeleteJobIndex] = useState(null);
  const [saveConfirmModal, setSaveConfirmModal] = useState(false);
  const [confirmCloseModal, setConfirmCloseModal] = useState(false);
  const {
    TEXT_CREATE_NEW_TIMESHEET,
    TEXT_ADD_JOBS,
    BTN_SUBMIT,
    TEXT_SUBMIT_MODAL_DESC,
    TEXT_UNSAVE_CHANGES,
    TEXT_LEAVE,
    TEXT_TODAY,
    TEXT_DATE
  } = ClientEnglishFallback?.ClientTimesheetManualComponent(
    multiLanguageData?.ClientTimesheetManualComponent || {}
  );

  const { TEXT_CANNOT_BE_UNDONE, TEXT_DELETE_HEADER } = ClientEnglishFallback?.ConfirmModal(
    multiLanguageData?.ConfirmModal || {}
  );

  const handleJobImagesUpload = async (timesheetData) => {
    try {

      const timesheetId = timesheetData?.ClientTimesheetId

      const resData = timesheetData?.ClientTimesheetJobs

      const imagePromise = []

      const finalData = jobs.forEach((item) => {
        const pictureList = item?.pictureList || []
        if (!pictureList.length) return

        const specificID = resData?.find((res) => {
          if (item?.id) {
            if (res.ClientJobActivityId == item?.id && res.ClientJobId === item.clientJobId) {
              return res
            }
          } else if (res.ClientJobActivityId == 0 && res.ClientJobId === item.clientJobId) {
            return res
          }
        })
        pictureList.forEach(async(file) => {
          const formData = new FormData();
          formData.append("Id", 0);
          formData.append("ClientActivityId", specificID?.ClientJobActivityId);
          formData.append("FileName", file.file);
          formData.append("ModifiedBy", loginData?.userInformation?.UserId);
          formData.append("ClientTimesheetJobId", specificID?.ClientTimesheetJobId);
          formData.append("ClientTimesheetId", timesheetId);
          formData.append("ClientJobId", specificID?.ClientJobId);

          const pm = await Fileuploadrequestcall(
            SAVE_CLIENT_TIMESHEET_JOB_IMAGES,
            formData,
            loginData?.accessToken
          )

          imagePromise.push(pm)

        })


      })

      if (imagePromise.length > 0) {
        await Promise.all(imagePromise);
      }

    } catch (error) {
      console.error("handleJobImagesUpload-> Error in handleJobImagesUpload: ", error);
    }
  };

  const convertToDecimal = (value) => {
    try {
      if (value === null || value === undefined) return 0;
      if (typeof value === "number") return value;

      if (typeof value === "string" && value.includes(":")) {
        const [hours, minutes] = value.split(":").map(Number);
        return hours + minutes / 60;
      }

      return parseFloat(value) || 0;
    } catch (error) {
      console.error("Error in convertToDecimal:", error);
      return 0;
    }
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      if (jobs?.length === 0) return;

      const timesheetObj = prepareTimesheetData(jobs);
      const res = await saveTimesheet(timesheetObj);

      let timesheetData = null;

      if (res?.status === 201) {
        timesheetData = res.data.data[0].objData;

      }


      await handleJobImagesUpload(timesheetData, jobs);

      reloadData();
      handleClose();
    } catch (error) {
      console.error("Error in handleSave:", error);
    } finally {
      setLoading(false);
    }
  };

  const saveTimesheet = async (timesheetObj) => {
    try {
      return Postrequestcall(SAVE_CLIENT_TIMESHEETS_NEW, timesheetObj, loginData?.accessToken);
    } catch (error) {
      console.error("Error in saveTimesheet:", error);
    }
  };

  const prepareTimesheetData = (jobs, clientTimesheetId = 0) => {
    try {
      const timeSheetJobList = jobs.map((job) => {
        const JOBSudFields = getudFieldsString(job?.clientJobUDFieldsList);
        const udFields = getudFieldsString(job?.clientActivitiesUDFieldsList);

        let mileage = 0;
        const rawMileage = _.get(job, "mileage", 0);
        if (rawMileage !== null && rawMileage !== undefined) {
          mileage = typeof rawMileage === "string" ? parseFloat(rawMileage) : rawMileage;
          if (isNaN(mileage)) mileage = 0;
        }

        const numericHours = convertToDecimal(_.get(job, "hours", 0)) || 0;
        const HoursDecimal = parseFloat(Number(numericHours).toFixed(2));
        const activityId = _.get(job, "activityId", 0) || 0;

        return {
          Id: FOR === "MANUALEDIT" ? job.id : 0,
          Notes: _.get(job, "notes", ""),
          UDFields: JOBSudFields || "",
          Deleted: false,
          clockInTime: "00:00",
          clockOutTime: "00:00",
          ClientJobId: job.clientJobId,
          ClientEmployeeId: EMPid,
          ClientJobActivityId: activityId,
          ClockInLatitude: 0,
          ClockOutLatitude: 0,
          ClockInLongitude: 0,
          ClockOutLongitude: 0,
          Hours: HoursDecimal,
          ActivityUDFields: udFields || "",
          Mileage: mileage,
          MileageUnit: _.get(job, "mileageUnit", "km")
        };
      });

      return {
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: clientTimesheetId || 0,
            DateSubmitted: dayjs().toISOString(),
            Date: dayjs(date).toISOString(),
            TypeId: 1,
            StatusId: 1,
            ClientId: _.get(selectedClientData, "ClientId", 0),
            Deleted: false,
            timeSheetJobList
          }
        ]
      };
    } catch (error) {
      console.error("Error in prepareTimesheetData:", error);
    }
  };

  const getudFieldsString = (data) => {
    if (!data?.length) return "";

    const fieldsObject = data.reduce((acc, item) => {
      acc[item.id] = item.fieldDefaultValue === "true" ? 1 : 0;
      return acc;
    }, {});

    return JSON.stringify(fieldsObject);
  };

  const clearTheData = () => {
    setDate(dayjs());
    setJobs([]);
  };

  const handleBackClick = () => {
    clearTheData();
    setView(VIEW.SELECT_JOBS);
    setModelState("HOME");
  };

  const handelExpand = useCallback((index) => {
    setJobs((prev) =>
      prev.map((item, i) => (i === index ? { ...item, expanded: !item?.expanded } : item))
    );
  }, []);

  const handelAddImage = useCallback(async (e, index) => {
    try {
      let files = Array.from(e.target.files);
      files = files.filter((file) => file.type.startsWith("image/"));
      const compressPromises = files.map((file) => imageCompress(file));
      const compressedImages = await Promise.all(compressPromises);

      const newImages = compressedImages.map((img) => ({ file: img }));

      setJobs((prev) =>
        prev.map((item, i) =>
          i === index ? { ...item, pictureList: [...(item.pictureList || []), ...newImages] } : item
        )
      );
    } catch (error) {
      console.error("handelAddImage-> Error adding images:", error);
    }
  }, []);

  const handelDelete = useCallback((index) => {
    setDeleteModal(true);
    setDeleteJobIndex(index);
  }, []);

  const handelConfirmDelete = useCallback(() => {
    setJobs((prev) => prev.filter((_, i) => i !== deleteJobIndex));
    setDeleteModal(false);
  }, [deleteJobIndex]);

  const handelActivityUdFieldChange = useCallback((e, jobIndex, udFieldIndex) => {
    try {
      let value = e.target.checked;
      setJobs((prev) => {
        return prev.map((item, ind) => {
          if (ind === jobIndex) {
            return {
              ...item,
              clientActivitiesUDFieldsList: item.clientActivitiesUDFieldsList.map((act, id) =>
                id == udFieldIndex
                  ? {
                    ...act,
                    fieldDefaultValue: value ? "true" : "false"
                  }
                  : act
              )
            };
          }
          return item;
        });
      });
    } catch (error) {
      console.error("handelActivityUdFieldChange-> Error Handling Acivity UD Field Change: ", error);
    }
  }, []);

  const handelJobsUdFieldChange = useCallback((e, jobIndex, udFieldIndex) => {
    try {
      let value = e.target.checked;
      setJobs((prev) => {
        return prev.map((item, ind) => {
          if (ind == jobIndex) {
            let a = {
              ...item,
              clientJobUDFieldsList: item.clientJobUDFieldsList.map((act, id) =>
                id == udFieldIndex
                  ? {
                    ...act,
                    fieldDefaultValue: value ? "true" : "false"
                  }
                  : act
              )
            };

            return a;
          }

          return item;
        });
      });
    } catch (error) {
      console.error("handelJobsUdFieldChange-> Error Handling Job UD Field Change: ", error);
    }
  }, []);

  const handelImageRemove = useCallback((imageIndex, jobIndex) => {
    setJobs((prev) =>
      prev.map((item, idx) =>
        idx === jobIndex
          ? {
            ...item,
            pictureList: item.pictureList.filter((_, i) => i !== imageIndex)
          }
          : item
      )
    );
  }, []);

  const handelMilageUnitChange = useCallback((e, index) => {
    const value = e;
    setJobs((prev) =>
      prev.map((item, i) =>
        i === index
          ? {
            ...item,
            mileageUnit: value
          }
          : item
      )
    );
  }, []);

  const handelFieldsChange = useCallback((e, index, field) => {
    try {
      const updateJobsField = (value) => {
        setJobs((prev) =>
          prev.map((item, i) =>
            i === index
              ? {
                ...item,
                [field]: value
              }
              : item
          )
        );
      };

      updateJobsField(e);
    } catch (error) {
      console.log('handelFieldsChange-> Error When Handling Field Change: ', error);
    }
  }, []);

  // HOURS:
  const handleTimeChange = useCallback((hours, minutes, index) => {
    try {
      const h = hours === "" || hours === null || hours === undefined ? 0 : Number(hours);
      const m = minutes === "" || minutes === null || minutes === undefined ? 0 : Number(minutes);
      const mPad = String(Math.max(0, Math.min(59, Math.floor(m)))).padStart(2, "0");
      const hoursString = `${Math.max(0, Math.min(24, Math.floor(h)))}:${mPad}`;

      setJobs((prev) =>
        prev.map((item, i) =>
          i === index
            ? {
              ...item,
              hours: hoursString,
              minutes: m
            }
            : item
        )
      );
    } catch (error) {
      console.log("handleTimeChange-> Error When Handling Time Change: ", JSON.stringify(error, null, 2));
    }
  }, []);

  // MILEAGE:
  const handleMileageChange = useCallback((value, index) => {
    try {
      const sanitizedText = value.replace(/[^\d.]/g, "").replace(/(\..*)\./g, "$1");

      let formattedMileage = "";

      if (sanitizedText.includes(".")) {
        const [integer, decimal] = sanitizedText.split(".");
        formattedMileage = `${integer.slice(0, 3)}.${decimal.slice(0, 1)}`;
      } else if (sanitizedText?.length <= 3) {
        formattedMileage = sanitizedText;
      } else {
        formattedMileage = `${sanitizedText.slice(0, 3)}.${sanitizedText.slice(3, 4)}`;
      }

      setJobs((prev) =>
        prev.map((item, i) =>
          i === index
            ? {
              ...item,
              mileage: formattedMileage
            }
            : item
        )
      );
    } catch (error) {
      console.log("handleMileageChange-> Error When Handling Mileage Change: ", JSON.stringify(error, null, 2));
    }
  }, []);

  const handleBlurMileage = useCallback((index) => {
    try {
      setJobs((prev) => {
        return prev.map((item, i) => {
          if (i !== index || item.mileage === "" || item.mileage == undefined) {
            return item;
          }
          let [integer, decimal] = (item.mileage + ".").split(".");
          integer = integer.padStart(1, "0").slice(0, 3);
          decimal = decimal.padEnd(1, "0").slice(0, 1);

          return {
            ...item,
            mileage: `${integer}.${decimal}`
          };
        });
      });
    } catch (error) {
      console.log("handleBlurMileage-> Error When Handling Mileage Blue: ", JSON.stringify(error, null, 2));
    }
  }, []);

  return (
    <>
      <Stack
        mb={1}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        flexDirection={"row"}>
        {modelState === "HOME" ? (
          <Typography variant="h5" fontWeight={"bold"}>
            {TEXT_CREATE_NEW_TIMESHEET}
          </Typography>
        ) : (
          <>
            {VIEW.SELECT_JOBS === view && (
              <IconButton
                size="small"
                onClick={() => {
                  if (jobs?.length > 0) {
                    setView(VIEW.LISTING);
                  } else {
                    setModelState("HOME");
                  }
                }}>
                <ArrowBackIcon />
              </IconButton>
            )}
          </>
        )}
        <IconButton onClick={() => setConfirmCloseModal(true)} style={{ padding: "4px" }}>
          <CloseIcon />
        </IconButton>
      </Stack>

      {view === VIEW.SELECT_JOBS && (
        <SelectJobsManual setView={setView} setSelectJobData={setJobs} selectedJobData={jobs} />
      )}
      {view === VIEW.LISTING && (
        <Stack gap={1}>
          <Stack
            sx={{
              backgroundColor: "white",
              padding: "10px",
              borderRadius: "8px"
            }}>
            <TodayDatePicker date={date} label={TEXT_DATE} setDate={setDate} />
          </Stack>
          <Stack gap={1} maxHeight={"450px"} overflow={"scroll"} sx={{ scrollbarWidth: "none" }}>
            {jobs.map((item, index) => (
              <JobsListingManual
                key={index}
                item={item}
                index={index}
                CLIENT_COLOR={CLIENT_COLOR}
                handelDelete={handelDelete}
                handelExpand={handelExpand}
                handelAddImage={handelAddImage}
                handelTimeChange={handleTimeChange}
                handelImageRemove={handelImageRemove}
                handleBlurMileage={handleBlurMileage}
                handelMileageChange={handleMileageChange}
                handelFieldsChange={handelFieldsChange}
                handelMilageUnitChange={handelMilageUnitChange}
                handelJobsUdFieldChange={handelJobsUdFieldChange}
                handelActivityUdFieldChange={handelActivityUdFieldChange}
              />
            ))}
            <Button
              onClick={() => {
                setView(VIEW.SELECT_JOBS);
              }}
              sx={{
                borderRadius: "10px",
                boxShadow: "none",
                bgcolor: "white",
                color: CLIENT_COLOR,
                textTransform: "none"
              }}>
              {TEXT_ADD_JOBS}
            </Button>
          </Stack>
          <LoadingButton
            loading={loading}
            variant="contained"
            startIcon={<></>}
            disabled={jobs?.length === 0 || jobs.some((item) => convertToDecimal(item?.hours) === 0)}
            onClick={() => setSaveConfirmModal(true)}
            sx={{
              marginTop: "10px",
              borderRadius: "10px",
              boxShadow: "none",
              color: "white",
              bgcolor:
                jobs?.length === 0 || jobs.some((item) => convertToDecimal(item?.hours) === 0)
                  ? "lightgray"
                  : CLIENT_COLOR
            }}>
            {BTN_SUBMIT}
          </LoadingButton>
        </Stack>
      )}

      <DeletConfirmModal
        isOpen={deleteModal}
        onClose={() => setDeleteModal(false)}
        onConfirm={() => {
          handelConfirmDelete();
        }}
        title={TEXT_CANNOT_BE_UNDONE}
        heading={TEXT_DELETE_HEADER}
      />

      <ConfirmModal
        confirmButtonText={BTN_SUBMIT}
        isOpen={saveConfirmModal}
        title={TEXT_SUBMIT_MODAL_DESC}
        onConfirm={() => {
          setSaveConfirmModal(false);
          handleSave();
        }}
        onClose={() => setSaveConfirmModal(false)}
      />
      <ConfirmModal
        isOpen={confirmCloseModal}
        confirmButtonText={TEXT_LEAVE}
        title={TEXT_UNSAVE_CHANGES}
        onConfirm={() => {
          setConfirmCloseModal(false);
          handleBackClick();
        }}
        onClose={() => setConfirmCloseModal(false)}
      />
    </>
  );
}
